import { useQuery } from "@tanstack/react-query";

import { useAppContext } from "./useAppContext";
import { useErrorHandling } from "./useErrorHandling";
import { useProduct } from "./useProduct";

/** The colors allowed for this product, this is fetched from the server */
export function useProductColors() {
	const { client, reactQueryNoReloadOptions } = useAppContext();
	const product = useProduct();
	const { createErrorHandler } = useErrorHandling();

	const loadColors = async () => {
		if (!product?.code) return [];

		const colors = client.getColorPaletteColorsAsync({
			code: product.code,
			isEmbroidery: product.isEmbroidery,
		});

		colors
			.then((d) => {
				if (!d || !d.length) {
					// log ProductWarning to server
					client.logErrorAsync(
						new eXpress.ProductWarning(
							"Empty color tab shown in Creator",
							`No colors found for product ${product.code}`,
						),
						false,
					);
				}
			})
			.catch(createErrorHandler());

		return colors;
	};

	return useQuery(["useProductColors", product?.code], loadColors, reactQueryNoReloadOptions);
}
